<template>
    <div>
        <v-divider></v-divider>
        <v-card>
            <v-container class="filter-heading">
                <v-layout justify-space-between align-content-center>
                    <v-flex>
                        <h3 class="mt-3 red--text">{{ $t('Core.GDPR.privacy_title') }}</h3>
                    </v-flex>

                    <user-heading></user-heading>
                </v-layout>
            </v-container>
        </v-card>
        <v-layout justify-center wrap class="my-4">
            <v-flex xs12 md8>
                <material-card
                        color="red">
                    <v-container grid-list-md>
                        <v-layout wrap v-html="$t('Core.GDPR.msg')">
                        </v-layout>
                    </v-container>

                </material-card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import userHeading from '@/components/core/UserHeading'

export default {
    data() {
        return {}
    },
    components: {
        'user-heading': userHeading
    },
}
</script>

<style>

</style>
